import { useEventDataOfSelectedEvent } from "@Utils";

export const useCustomCode = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const codes = eventData?.custom_codes || [];
    return { codes };
};
